import { useTranslation } from "react-i18next";
import { Tooltip } from "../tooltip";
import Style from "./ChartStatus.module.scss";

type Props = {
	status: string;
	low: string;
	average: string;
	high: string;
	withoutBackgroundColor?: boolean;
	/** Optional swatch color overrides. When omitted, the SCSS var-driven defaults render unchanged. */
	lowColor?: string;
	averageColor?: string;
	highColor?: string;
};

export function ChartStatus({ status, low, average, high, withoutBackgroundColor, lowColor, averageColor, highColor }: Props) {
	const { t } = useTranslation();
	return (
		<div className={Style.status} style={withoutBackgroundColor ? { backgroundColor: "transparent" } : {}}>
			<div className={Style.statusContainer}>
				<Tooltip id="status" text={t("tooltip.status")} component={<div className={Style.statusTitle}>{status}</div>} />
				<div className={Style.statusContent}>
					<div className={Style.content}>
						<div className={Style.ellipseBlue} style={lowColor ? { backgroundColor: lowColor } : undefined} />
						<div className={Style.ellipseName}>{low}</div>
					</div>
					<div className={Style.content}>
						<div className={Style.ellipseGrey} style={averageColor ? { backgroundColor: averageColor } : undefined} />
						<div className={Style.ellipseName}>{average}</div>
					</div>
					<div className={Style.content}>
						<div className={Style.ellipseYellow} style={highColor ? { backgroundColor: highColor } : undefined} />
						<div className={Style.ellipseName}>{high}</div>
					</div>
				</div>
			</div>
		</div>
	);
}
